module.exports = __webpack_public_path__ + "img/15db0288-3444-4859-ba50-f63ffe34cfea.859b100e.png";